'use client';

import { c as _c } from "react/compiler-runtime";
import { PortfolioLoadingSkeleton } from '@/components/portfolio/portfolio-loading-skeleton';
import { usePathname } from '@/i18n/navigation';
import { stripDemoModePath } from '@/lib/network';
import MarketDetailLoading from '../../markets/[pubkey]/loading';
import MarketsLoading from '../../markets/loading';
import PortfolioDetailLoading from '../../portfolio/[user_id]/loading';
import ProposalDetailLoading from '../../proposals/[proposalId]/loading';
import LaunchpadLoading from '../../proposals/loading';
import CompetitionLoading from '../../social/competitions/[competitionId]/loading';
import CompetitionsLoading from '../../social/competitions/loading';
import SocialLoading from '../../social/loading';
import WinnerDetailLoading from '../../winners/[mint]/loading';
import WinnersLoading from '../../winners/loading';

// Route-level Suspense fallback for EVERY `/demo-mode/*` surface. A server
// `loading.tsx` receives no params, so the previous version rendered a single
// surface-neutral chrome skeleton for every tab. This client version reads the
// destination pathname (`usePathname` reflects it immediately during a soft
// navigation), strips the `/demo-mode` prefix, and dispatches on the first
// segment to the matching per-surface skeleton — mirroring `dispatchSlug` in
// the sibling `page.tsx`. The per-surface loaders are pure presentational
// components, so importing them into a client component is safe.
//
// The default branch (FQ-145) is the markets/listing skeleton so the body slot
// is NEVER blank, even for an unknown segment.
export default function DemoModeCatchAllLoading() {
  const $ = _c(14);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    const stripped = stripDemoModePath(pathname);
    t0 = stripped.split("/").filter(Boolean);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const segments = t0;
  const [first, second, third] = segments;
  switch (first) {
    case "markets":
      {
        let t1;
        if ($[2] !== second) {
          t1 = second === undefined ? <MarketsLoading /> : <MarketDetailLoading />;
          $[2] = second;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "winners":
      {
        let t1;
        if ($[4] !== second) {
          t1 = second === undefined ? <WinnersLoading /> : <WinnerDetailLoading />;
          $[4] = second;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "proposals":
      {
        let t1;
        if ($[6] !== second) {
          t1 = second === undefined ? <LaunchpadLoading /> : <ProposalDetailLoading />;
          $[6] = second;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "social":
      {
        if (second === "competitions") {
          let t1;
          if ($[8] !== third) {
            t1 = third === undefined ? <CompetitionsLoading /> : <CompetitionLoading />;
            $[8] = third;
            $[9] = t1;
          } else {
            t1 = $[9];
          }
          return t1;
        }
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <SocialLoading />;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        return t1;
      }
    case "portfolio":
      {
        let t1;
        if ($[11] !== second) {
          t1 = second === undefined ? <PortfolioLoadingSkeleton pnlViewerMode="own" /> : <PortfolioDetailLoading />;
          $[11] = second;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <MarketsLoading />;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
  }
}